<div>
  <svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [style.opacity]="opacity"
  >
    @if(hasGradient) {
    <defs>
      <linearGradient
        [attr.id]="gradientId"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="14"
        y2="14"
      >
        <stop offset="0%" [style.stop-color]="startColor" />
        <stop offset="100%" [style.stop-color]="endColor" />
      </linearGradient>
    </defs>
    }
    <path
      d="M4.5 7C4.5 6.3035 4.539 5.633 4.611 5H9.389C9.461 5.633 9.5 6.3035 9.5 7C9.5 7.6965 9.461 8.367 9.389 9H4.611C4.53691 8.33591 4.49985 7.66821 4.5 7ZM3.605 9C3.53487 8.33564 3.49982 7.66805 3.5 7C3.5 6.3105 3.5365 5.64 3.605 5H0.290003C0.0971041 5.64913 -0.000580306 6.32282 2.5933e-06 7C2.5933e-06 7.695 0.101503 8.3665 0.290003 9H3.605ZM0.673503 10H3.7425C3.8995 10.93 4.128 11.7735 4.4145 12.489C4.599 12.95 4.811 13.368 5.0505 13.725C4.09941 13.4481 3.21769 12.973 2.46331 12.331C1.70893 11.689 1.09896 10.8946 0.673503 10ZM4.7575 10H9.2425C9.0975 10.8 8.8975 11.516 8.6575 12.1175C8.3995 12.7615 8.1055 13.2485 7.8045 13.5675C7.5045 13.8845 7.2325 14 7 14C6.7675 14 6.4955 13.8845 6.1955 13.567C5.8945 13.2485 5.6005 12.7615 5.343 12.1175C5.1025 11.516 4.9025 10.7995 4.7575 10ZM10.2575 10C10.1005 10.93 9.872 11.7735 9.5855 12.489C9.401 12.95 9.189 13.368 8.9495 13.725C9.9006 13.4481 10.7823 12.973 11.5367 12.331C12.2911 11.689 12.901 10.8946 13.3265 10H10.2575ZM13.71 9C13.8985 8.3665 14 7.695 14 7C14 6.305 13.8985 5.6335 13.71 5H10.395C10.4635 5.64 10.5 6.3105 10.5 7C10.5 7.6895 10.4635 8.36 10.395 9H13.71ZM8.657 1.8825C8.8975 2.484 9.0975 3.2005 9.2425 4H4.7575C4.9025 3.2 5.1025 2.484 5.3425 1.8825C5.6005 1.2385 5.8945 0.751 6.1955 0.4325C6.4945 0.117 6.7655 0.001 6.9975 0H7.0015C7.2335 0 7.505 0.1165 7.8045 0.433C8.1055 0.751 8.3995 1.2385 8.657 1.8825ZM10.2575 4H13.3265C12.901 3.10543 12.2911 2.31103 11.5367 1.66902C10.7823 1.02702 9.9006 0.551932 8.9495 0.275C9.189 0.632 9.401 1.05 9.5855 1.511C9.872 2.2265 10.1005 3.07 10.2575 4ZM0.673503 4H3.7425C3.8995 3.07 4.128 2.2265 4.4145 1.511C4.599 1.05 4.811 0.632 5.0505 0.275C4.09941 0.551932 3.21769 1.02702 2.46331 1.66902C1.70893 2.31103 1.09896 3.10543 0.673503 4Z"
      [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
    />
  </svg>
</div>
